import { CommonModule } from '@angular/common';
import { Component, Inject, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ConfirmationWithCheckConfig } from './confirm-with-check-dialog.types';

@Component({
    selector: 'confirmation-with-check-dialog',
    templateUrl: './confirm-with-check-dialog.component.html',
    styles: [
        /* language=SCSS */
        `
            .confirmation-with-check-dialog-panel {
                @screen md {
                    @apply w-128;
                }

                .mat-mdc-dialog-container {

                    .mat-mdc-dialog-surface {
                        padding: 0 !important;
                    }
                }
            }
        `
    ],
    imports: [CommonModule, ReactiveFormsModule, FormsModule, MatCheckboxModule, MatButtonModule, MatDialogModule, MatIconModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    encapsulation: ViewEncapsulation.None
})
export class ConfirmationWithCheckDialogComponent {

    checked = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: ConfirmationWithCheckConfig,
        public matDialogRef: MatDialogRef<ConfirmationWithCheckDialogComponent>
    ) { console.log(data)}

}
